import {
  instagramLink,
  tikTokLink,
} from "@repo/components/src/utils/socialNetworkUser";
import { PlatformCodeEnum } from "@repo/graphql/gql/graphql";

export function formatFollowers(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return String(n);
}

export function getSocialLink(
  platformCode: string,
  username: string,
): string | null {
  if (platformCode === PlatformCodeEnum.Instagram)
    return instagramLink(username);
  if (platformCode === PlatformCodeEnum.TikTok) return tikTokLink(username);
  return null;
}

export function countryCodeToEmoji(code: string): string {
  return [...code.toUpperCase()]
    .map((c) => String.fromCodePoint(0x1f1e6 - 65 + c.charCodeAt(0)))
    .join("");
}
